import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { latLng, tileLayer, circle, polygon, marker, icon, Layer, Browser } from 'leaflet';
import { Map, geoJSON } from 'leaflet';
import { NotificationsService } from 'src/app/shared/notifications.service';
import * as L from 'leaflet';


@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.scss']
})


export class MapsComponent implements OnChanges, OnInit {

	@Input() center : any;
	@Input() latitude : any;
	@Input() longitude: any;

  map!: Map;
  technicalInformation: any;
  markers: any;
  markersLayers: any;
  zoom: any;
 // center: any;
  formZoom: any;
  zoomLevels: any;

  constructor(
  ) { }

  ngOnInit(): void {
    this.functionLatAlt();
    L.Icon.Default.imagePath = "assets/leaflet/" 
  }

  ngOnChanges() {
    this.functionLatAlt();
  }

  functionLatAlt() {
    
    this.markers = {
      zoom: 15,
      layers: [
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          minZoom: 8, 
          maxZoom: 16,
          attribution: 'leaflet',
          id: 'map',

        })
      ],
      center: latLng(this.latitude, this.longitude),
    };

    this.zoom = this.markers.zoom;
    this.center = latLng(this.markers.center);
    // Form bindings
    this.formZoom = this.zoom;
    this.zoomLevels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];
    this.latitude === null ? this.latitude: this.latitude;
    this.longitude === null ? this.longitude: this.longitude;

    

    this.markersLayers = [
      circle([this.latitude, this.longitude], {
        color: '#34c38f',
        fillColor: '#34c38f',
        radius: 100,
      }),
      marker([this.latitude, this.longitude]),
    ];
  }



}
